// Animated Background Component - CSS-only version (optimized for mobile/Safari)
// Creates depth effect without JavaScript animations

const AnimatedBackground = () => {
  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none" style={{ zIndex: 0 }}>
      {/* Gradient ambient glow - Violet themed */}
      <div className="absolute top-0 left-[10%] w-[500px] h-[500px] bg-primary/5 rounded-full blur-[150px]" />
      <div className="absolute bottom-[20%] right-[5%] w-[400px] h-[400px] bg-primary/3 rounded-full blur-[120px]" />
      <div className="absolute top-[40%] right-[30%] w-[300px] h-[300px] bg-pink-500/3 rounded-full blur-[100px]" />
      
      {/* Static decorative elements - no animations for performance */}
      <div className="absolute top-[12%] left-[8%] w-14 h-14 bg-primary/5 rounded-2xl border border-primary/5 opacity-50" />
      <div className="absolute top-[22%] right-[12%] w-16 h-16 bg-pink-500/5 rounded-2xl border border-pink-500/5 opacity-50" />
      <div className="absolute top-[58%] left-[6%] w-12 h-12 bg-gold/5 rounded-xl border border-gold/5 opacity-50" />
      <div className="absolute top-[68%] right-[14%] w-14 h-14 bg-primary/5 rounded-2xl border border-primary/5 opacity-50" />
      
      {/* Pulsing glow - CSS animation, no JS */}
      <div className="absolute top-[40%] left-[50%] -translate-x-1/2 w-[200px] h-[200px] bg-primary/3 rounded-full blur-[80px] animate-pulse" />
    </div>
  );
};

export default AnimatedBackground;
